import React from 'react'
import { BankTransactionsWithLinkedAccounts } from '@layerfi/components'
import { useOutletContext } from 'react-router-dom'

import { AccountingLayout } from '../../../layouts/AccountingLayout'
export const BankTransactions = () => {
  const {
    isMobileView,
    isBookkeepingMode,
    showDescriptions,
    showReceiptUploads,
    showTooltips,
    showCustomerVendor,
  } = useOutletContext<{
    isMobileView: boolean
    isBookkeepingMode: boolean
    showDescriptions: boolean
    showReceiptUploads: boolean
    showTooltips: boolean
    showCustomerVendor: boolean
  }>()

  return (
    <AccountingLayout>
      <BankTransactionsWithLinkedAccounts
        showLedgerBalance={false}
        mode={isBookkeepingMode ? 'bookkeeping-client' : 'self-serve'}
        showDescriptions={showDescriptions}
        showReceiptUploads={showReceiptUploads}
        showTooltips={showTooltips}
        mobileComponent={isMobileView ? 'mobileList' : 'regularList'}
        showTags
        showCustomerVendor={showCustomerVendor}
        showUploadOptions
        showCategorizationRules={true}
      />
    </AccountingLayout>
  )
}
